import type { IStep, StepState } from '@lqa-frontend/ui-system';

export function resolveState(
	step: IStep,
	currentStep: number,
	stepIndex: number
): StepState {
	if (step.state) {
		return step.state;
	} else if (stepIndex < currentStep) {
		return 'completed';
	} else if (stepIndex > currentStep) {
		return 'disabled';
	}

	return 'normal';
}
